import React from 'react';
import './styles.css';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormLabel, FormControl, FormControlLabel, FormHelperText } from 'material-ui/Form';

const Question = ({
  question,
  index,
  questions,
  onClick,
  answers,
  changeAnswerValue
}) => (
  <div>
    <div className="modal-content">
      {questions.indexOf(question) + 1}/{questions.length}
      <p className="test_text_question">
        {question.question}
      </p>
      <FormControlLabel value="male" control={<Radio
        onChange={(e) => changeAnswerValue(question.id, true)}
        checked={answers[question.id] == true}
      />} label="True" />
      <br />
      <FormControlLabel value="male" control={<Radio
        onChange={(e) => changeAnswerValue(question.id, false)}
        checked={answers[question.id] == false}
      />} label="False" />
      <div className="submit_center col s12">
        <button onClick={answers[question.id] == null ? ()=>{} : onClick} className="test_submit">
          NEXT
        </button>
      </div>
    </div>
  </div>
)

export default Question;



/** WEBPACK FOOTER **
 ** ./src/components/Quiz/Question.jsx
 **/